import { render, staticRenderFns } from "./DropDownPortfolioRoles.vue?vue&type=template&id=70fc1cb4"
import script from "./DropDownPortfolioRoles.vue?vue&type=script&lang=js"
export * from "./DropDownPortfolioRoles.vue?vue&type=script&lang=js"
import style0 from "./DropDownPortfolioRoles.vue?vue&type=style&index=0&id=70fc1cb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports